import { loadStripe } from '@stripe/stripe-js';

// Your Stripe publishable key - uses environment variable for production
const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_test_51Oy1AVDOXUC0Tj0l9xFE2XSdIWkJFUqzuI6i5lAAhY7eSJuYrEtFAeReZJLGJcSmwvBb2h9vCf2laQLaWTzpXkc7005gHzHVhs';

let stripePromise;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// Create checkout session
export const createCheckoutSession = async ({
  amount,
  planTitle,
  duration,
  multiplier,
  currency = 'usd',
  metadata = {},
  customerEmail,
}) => {
  try {
    // Use environment variable for backend URL, fallback to localhost for development
    const backendUrl =
      process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

    const response = await fetch(`${backendUrl}/api/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount,
        currency: String(currency || 'usd').toLowerCase(),
        planTitle,
        duration,
        multiplier,
        customerEmail, // always send top-level
        metadata: {
          ...metadata,
          customerEmail, // redundancy inside metadata
        },
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create checkout session');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};

// Payment Intent (kept for future use)
export const createPaymentIntent = async (amount, currency = 'usd') => {
  try {
    const backendUrl =
      process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

    const response = await fetch(`${backendUrl}/api/create-payment-intent`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount: amount * 100, // Convert to cents
        currency: currency,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create payment intent');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating payment intent:', error);
    throw error;
  }
};
